module.exports = __webpack_public_path__ + "static/media/compress-wide.3b9addcf.svg";